import { router } from '@/router'
import { Auth } from '@/models/auth'
import { User } from '@/models/user'
import { UserAPI, IResetPasswordInput } from '@/api/user.api'
import { BASE_PATH_APP, APP_PREFIX_AUTH } from '@/commons/config'

import JwtDecode from 'jwt-decode'
import GlobalStore from '@/store/modules/global'

import { map } from 'rxjs/operators'
import { BehaviorSubject, Observable } from 'rxjs'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

const AUTH = `${APP_PREFIX_AUTH}@auth`
const userApi = new UserAPI()

const currentUser = () => {
  try {
    const { token = null, functionalities = [] } = JSON.parse(localStorage.getItem(AUTH)) || {}

    if (!token) return null

    const { sub, name, username, email, roles, sector, crea, profile } = JwtDecode<any>(token)
    return new User(sub, name, username, email, sector, functionalities, roles, crea, profile)
  } catch (err) {
    localStorage.removeItem(AUTH)
    router.push({name: 'login'})
    return null
  }
}

const userSubject = new BehaviorSubject(currentUser())

userSubject.subscribe(user => {
  if (GlobalStore) {
    GlobalStore.setUser(user)
  }
})

const login = (usernameOrEmail: string, password: string, returnUrl?: string): Observable<User> => {
  return userApi
    .signin(usernameOrEmail, password)
    .pipe(map(response => setSession(response, returnUrl)))
}

const logout = (): void => {
  localStorage.removeItem(AUTH)
  userSubject.next(null)
  setTimeout(()=>{router.push({name: 'login'})}, 100)
}

const setSession = (authResult: any, returnUrl: any): User => {
  buildAuth(authResult)

  userSubject.next(currentUser())
  router.push(returnUrl || '/')

  return userSubject.value
}

const buildAuth = ({ token, functionalities }: Auth) => {
  localStorage.setItem(AUTH, JSON.stringify({ token, functionalities }))
}

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {}
  return token
}

const forgotPassword = (email: string): AxiosObservable<any> => userApi.forgotPassword(email)

const resetPassword = (data: IResetPasswordInput): AxiosObservable<any> => userApi.resetPassword(data)

export default {
  login,
  logout,
  get currentUserValue () {
    return userSubject.value
  },
  get token () {
    return currentToken()
  },
  forgotPassword,
  resetPassword
}
